import { FORMA_PAGO } from "api/Types/FormaPago"
import { DATE_YYYY_MM_DD } from "common/components/FilterMenu/constants"
import { USUARIO_ORIGEN_BDE } from "common/constants"
import { removeMimeFromBase64 } from "common/utils/formats"
import { formatDate, toAlphaNumerics } from "common/utils/utils"

const prepareConceptos = (
  conceptos: $TSMigrationFixMe,
  sinValorar: $TSMigrationFixMe
) => {
  return conceptos.map((concepto: $TSMigrationFixMe) => ({
    articulo: {
      concepto: concepto.concepto,
      precioVenta: sinValorar ? null : concepto.precioVenta,
      tipoArticulo: 1,
    },

    impuestoEmpresaRepercutidoId: concepto.impuestoRepercutidoId,
    cantidad: concepto.cantidad,
    tarifaImpuesto: concepto.tarifaImpuesto,
  }))
}

const prepareUserData = (user: $TSMigrationFixMe) => ({
  cif: toAlphaNumerics(user?.cif),

  direccion: {
    calle: user?.direccion,
    codigoPostal: user?.cp,
    poblacionId: user?.poblacionId,
    poblacionExtranjera: user?.poblacionExtranjera,
  },

  email: user?.email,
  razonSocial: user?.razonSocial,
  telefono: user?.telefono,
})

export const mapFacturaOcr = ({
  divisa,
  documentoImportadoId,
  fechaEmision,
  importe,
  impuestos,
  retencion,
  libradoId,
  libradorId,
  serie,
}: $TSMigrationFixMe) => ({
  divisa,
  documentoImportadoId,
  fechaEmision: formatDate(fechaEmision, DATE_YYYY_MM_DD),
  importe,
  impuestos: impuestos.map(
    ({ baseImponible, porcentaje: { id }, total }: $TSMigrationFixMe) => ({
      baseImponible,
      id,
      total,
    })
  ),
  // TODO: OCR. Delete [0] when backend is ready
  retencion: retencion.map(
    ({ baseImponible, porcentaje: { id }, total }: $TSMigrationFixMe) => ({
      baseImponible,
      id,
      total,
    })
  )[0],
  libradoId,
  libradorId,
  serie,
})

const mapDocumentoToPost = (
  documento: $TSMigrationFixMe,
  sinValorar: $TSMigrationFixMe,
  observacionCesion: $TSMigrationFixMe,
  formaPagoIban: $TSMigrationFixMe,
  cuentaContable = null,
  isLibrador: $TSMigrationFixMe
) => {
  const files = [...(documento.archivosAdjuntos || [])]

  if (documento.logo) {
    files.push({
      fileAsBase64: removeMimeFromBase64(documento.logo),
      // TODO: Magic number
      tipo: 2,
    })
  }
  return {
    tipoDocumento: 2,
    documentosComercialesAsociadosIds: documento.documentosAsociadosId,
    articulosDocumento: prepareConceptos(documento.conceptos, sinValorar),
    cliente: prepareUserData(documento.cliente),
    proveedor: prepareUserData(documento.usuario),
    libradorId: documento.usuario?.id,
    libradoId: documento.cliente?.id,
    observaciones: observacionCesion
      ? `${observacionCesion}\n${documento.observaciones || ""}`
      : documento.observaciones || null,
    serie: documento.serie,
    numero: documento.numero,
    ficheros: files,
    configuracion: {
      color: documento.codigoHex,
    },
    ...(isLibrador && {
      fechaVencimiento:
        typeof documento.fechaVencimiento === "string"
          ? documento.fechaVencimiento
          : new Intl.DateTimeFormat("es-ES", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            })
              .format(documento.fechaVencimiento)
              .split("/")
              .reverse()
              .join("-"),
    }),
    ImpuestoEmpresaRetenidoId: sinValorar ? null : documento.impuestoRetenidoId,
    impuestoRetenido: documento.impuestoRetenido,
    tarifaImpuesto: sinValorar ? null : documento.tarifaImpuesto,
    descuento: sinValorar ? null : documento.descuento,
    diasPago: sinValorar ? null : documento.diasPago,
    divisa: documento.divisa,
    fechaEmision:
      typeof documento.fechaEmision === "string"
        ? documento.fechaEmision
        : new Intl.DateTimeFormat("es-ES", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })
            .format(documento.fechaEmision)
            .split("/")
            .reverse()
            .join("-"),
    fechaOperacion: documento.fechaOperacion
      ? new Date(documento.fechaOperacion)
      : null,
    formaPago: documento.formaPago,
    ...(isLibrador &&
      (documento.formaPago === FORMA_PAGO.TRANSFERENCIA ||
        documento.formaPago === FORMA_PAGO.PAGO_DOMICILIADO) &&
      formaPagoIban !== "" && { iban: formaPagoIban }),
    importe: sinValorar ? null : documento.importe,
    emailLibrado: documento.cliente?.email,
    libradorMdfId: documento.usuario?.libradorMdfId,
    usuarioOrigen: documento.usuarioOrigen || USUARIO_ORIGEN_BDE,
    documentoImportadoId: documento.documentoImportadoId || null,
    cuentaContableCategoriaId: cuentaContable,
  }
}

export default mapDocumentoToPost
